import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { IoArrowBack } from 'react-icons/io5';
import { MdBlock } from 'react-icons/md';
import { CgUnblock } from 'react-icons/cg';
import { Button, Modal } from 'react-bootstrap';
import * as apicall from '../../components/Apicall';
import Table from '../../components/Table';
import Skeleton from '../../components/SekeltonLoder';
import { toast } from 'react-toastify';

const UserDetails = () => {
  const serviceHeaders = ['Service Type', 'Selected Offerings', 'Booking Date', 'Service Time', 'Amount', 'Status'];
  const [serviceData, setServiceData] = useState([]);
  const [userServiceData, setUserServiceData] = useState([]);
  const [loadingServiceHistory, setLoadingServiceHistory] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [action, setAction] = useState(null);

  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location;
  const user = state?.user || {}; 

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const getUserServiceHistory = async () => {
    setLoadingServiceHistory(true);
    try {
      const res = await apicall.get(`user_bookings_history/${user.id}`);
      const formattedData = res.data.map(
        ({
          service_name,
          service_offering_name,
          service_date,
          service_time,
          user_payable_amount,
          calculated_price,
          status,
        }) => [
          service_name || '-',
          service_offering_name || '-',
          formatDate(service_date),
          service_time || '-',
          user_payable_amount
            ? `₹${user_payable_amount}`
            : calculated_price
            ? `₹${calculated_price}`
            : '-',
          status || '-',
        ]
      );
      setServiceData(formattedData);
      setUserServiceData(res.data);
    } catch (error) {
      console.error('Failed to fetch service history:', error);
      toast.error('Failed to load service history.');
    } finally {
      setLoadingServiceHistory(false);
    }
  };

  useEffect(() => {
    if (user?.id) {
      getUserServiceHistory();
    } else {
      console.error("User ID is missing. Cannot fetch service history.");
    }
  }, [user]);

  const handledetails = (index) => {
    const booking = userServiceData[index];
    if (booking?.booking_id) {
      navigate(`/bookingDetails/${booking.booking_id}`, {
        state: {
          bookingId: booking.booking_id,
        },
      });
    } else {
      console.error("Booking ID is undefined");
    }
  };

  const handleUserStatus = (status) => {
    setAction(status === 0 ? 'block' : 'unblock');
    setShowModal(true);
  };

  const handleClose = () => setShowModal(false);

  const toggleUserStatus = async () => {
    try {
      const status = action === 'block' ? 0 : 1;
      await apicall.get(`blockUser/${user.id}/${status}`);
      toast.success(`User ${action === 'block' ? 'blocked' : 'unblocked'} successfully!`);
      handleClose();
      navigate('/user');
    } catch (error) {
      toast.error(error.message || 'An error occurred while updating user status.');
    }
  };

  return (
    <div className="container bg-white my-4 p-3 shadow rounded-3">
      <div className="mb-2 d-flex align-items-center">
        <IoArrowBack size={24} className="me-2 pointer" onClick={() => navigate('/user')} />
        <h1 className="sub-heading mb-0">User Details</h1>
      </div>

      {user ? (
        <div>
          <div className="row Secondary-Variant">
            <h1 className="sub-heading mt-3">Basic Details</h1>
            <div className="col-12 p-3">
              <div className="row">
                {[
                  { label: 'First Name', value: user.first_name },
                  { label: 'Middle Name', value: user.middle_name },
                  { label: 'Last/Surname', value: user.last_name },
                  { label: 'Phone Number', value: user.phone_number },
                  { label: 'Email', value: user.email },
                  { label: 'Gender', value: user.gender },
                  { label: 'Country', value: user.country_name },
                  { label: 'State', value: user.state_name },
                  { label: 'City', value: user.city_name },
                ].map(({ label, value }, index) => (
                  <div className="col-4 mb-2" key={index}>
                    <p className="label mb-1">{label}</p>
                    <p className="content mb-1">{value || '-'}</p>
                  </div>
                ))}
              </div>
            </div>

            <div className="row">
              <div className="col-12 mt-3 text-start">
                <p className="content mb-1">
                  {user.is_active === 1 ? 'Block' : 'Unblock'} this user
                </p>
                <p className="label">
                  {user.is_active === 1 && 'This profile will be blocked temporarily.'}
                </p>
                <Button
                  variant="btn primaryColorText btn-outline-secondary"
                  onClick={() => handleUserStatus(user.is_active === 1 ? 0 : 1)}
                >
                  {user.is_active === 1 ? (
                    <span>
                      <MdBlock size={20} /> BLOCK
                    </span>
                  ) : (
                    <span>
                      <CgUnblock size={20} /> UNBLOCK
                    </span>
                  )}
                </Button>
              </div>
            </div>
          </div>

          <div className="row mb-3 secondary">
            <h1 className="sub-heading mt-3">Service History</h1>
            {loadingServiceHistory ? (
              <Skeleton height="30px" count={5} />
            ) : serviceData.length > 0 ? (
              <Table
                headers={serviceHeaders}
                data={serviceData}
                pagination={true}
                recordsCount={10}
                details={(index) => handledetails(index)}
              />
            ) : (
              <p className='d-flex justifiy'>No service history available</p>
            )}
          </div>
        </div>
      ) : (
        <Skeleton height="30px" count={5} />
      )}


      <Modal show={showModal} onHide={handleClose} centered size="xxl">
        <div className="d-flex flex-column justify-content-center align-items-center p-3 m-3">
          <p className="text-center mb-3">
            Are you sure? You want to {action} this user?
          </p>
          <div className="d-flex justify-content-center align-items-center mt-3">
            <button
              className="mx-1 btn Button primaryColorText btn-outline-secondary me-2 no-hover-effect"
              onClick={handleClose}
            >
              Cancel
            </button>
            <button
              className="btn Button primaryBackground text-white position-relative d-flex justify-content-center align-items-center"
              onClick={toggleUserStatus}
            >
              {action === 'block' ? 'Block' : 'Unblock'}
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default UserDetails;